import mountApp from './mountApp';

mountApp('ft5_upselling-service');
